'use client'

import { usePathname } from 'next/navigation'
import { useCallback, useEffect, useMemo, useRef } from 'react'

import { useNotificationContext } from '@maestro/commerce-blocks/components/notification/notification.context'
import { theme } from '@maestro/local/theme'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export const useAddedToCartNotification = () => {
  const {
    cart: { isSlidein },
    urls,
  } = theme()
  const pathname = usePathname()
  const { addOrUpdateHashParam, hash } = useHash()
  const { removeLastToast } = useNotificationContext()

  const notificationRef = useRef<HTMLDivElement>(null)

  const isVisibleActionButton = useMemo(() => {
    if (isSlidein) {
      return !hash.includes('cart')
    } else {
      return pathname !== urls.cart
    }
  }, [isSlidein, pathname, urls.cart, hash])

  const handleOpenCartModal = useCallback(() => {
    removeLastToast()
    addOrUpdateHashParam('cart')
  }, [addOrUpdateHashParam, removeLastToast])

  useEffect(() => {
    notificationRef.current?.focus()
  }, [])

  return {
    cartUrl: urls.cart,
    handleOpenCartModal,
    isSlidein,
    isVisibleActionButton,
    notificationRef,
  }
}
